import { apiConnector } from '../apiConnector';
import { subjectEndpoint } from '../api';

export const getAllSubjects = async () => {
	let result = [];
	try {
		const response = await apiConnector('GET', subjectEndpoint.GET_ALL_SUBJECTS);
		if (!response.data || !response.data.success) throw new Error('Could not fetch subjects');
		result = response.data;
	} catch (error) {
		console.error('GET ALL SUBJECTS API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

export const getSubjectsByBranch = async (branchId) => {
	let result = [];
	try {
		const response = await apiConnector('GET', subjectEndpoint.GET_SUBJECTS_BY_BRANCH(branchId));
		if (!response.data || !response.data.success) throw new Error('Could not fetch subjects for branch');
		result = response.data;
	} catch (error) {
		console.error('GET SUBJECTS BY BRANCH API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};

export const addSubject = async (branchId, subjectData) => {
	let result = {};
	try {
		const response = await apiConnector('POST', subjectEndpoint.ADD_SUBJECT(branchId), subjectData);
		result = response.data;
	} catch (error) {
		console.error('ADD SUBJECT API ERROR', error);
		result = error.response?.data || { success: false, message: error.message };
	}
	return result;
};
